<template>
  <div>
    <div class="grey lighten-5">
      <v-col cols="12" md="3">
        <v-btn
          class="btn btn-primary mr-4 mt-4"
          v-if="!createRole && permissions.includes('CAN_CREATE_ROLE')"
          @click="create()"
        >Create</v-btn>
        <v-btn class="btn btn-primary mr-4 mt-4" v-if="createRole" @click="createRole = false">List</v-btn>
      </v-col>
      <v-col cols="12" v-if="createRole">
        <v-text-field
          v-model="name"
          label="Enter Name"
          name="userName"
          id="userName"
          v-validate="'required'"
        ></v-text-field>
        <span class="text-danger">{{ errors.first('userName') }}</span>
        <div
          class="col-sm-12 border-bottom"
          v-for="(key, index) in permissionResponseData"
          :key="index"
        >
          <label>{{showingName(index)}}</label>
          <br />
          <label class="container-check mr-3" v-for="(item, j) in key" :key="j">
            <input
              type="checkbox"
              :checked="editRolePermissions.includes(item)"
              @change="selectPermission(item)"
              class="mr-1"
            />
            {{showingName(item)}}
            <span class="checkmarked"></span>
          </label>
        </div>
        <div class="text-right mt-3">
          <v-btn class="btn btn-danger mr-4" @click="close()">Cancel</v-btn>
          <v-btn class="btn btn-success mr-4" v-if="editRoleFlag" @click="editRoleData()">Submit</v-btn>
          <v-btn class="btn btn-success mr-4" v-if="!editRoleFlag" @click="createRoleData()">Submit</v-btn>
        </div>
      </v-col>
      <v-col cols="12" v-else>
        <div class="table-div">
          <table class="table">
            <thead>
              <tr class="table-success">
                <th scope="col">Name</th>
                <th v-if="permissions.includes('CAN_VIEW_PERMISSION_ROLE')" scope="col">Permission</th>
                <th scope="col">Is Active</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody v-for="(item, index) in roleDataList" :key="index">
              <tr>
                <td>{{ item.name }}</td>
                <td v-if="permissions.includes('CAN_VIEW_PERMISSION_ROLE')">
                  <a
                    @click="openPermissionModal(item.permissions)"
                    class="btn btn-primary mr-3 v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                  >View</a>
                </td>
                <td>{{ item.is_active ? 'Yes' : 'No' }}</td>
                <td>
                  <div class="d-flex justify-content-end">
                    <v-btn
                      v-if="permissions.includes('CAN_EDIT_ROLE')"
                      class="btn btn-primary mr-3"
                      @click="editRole(item)"
                    >Edit</v-btn>

                    <v-btn
                      @click="activationRole(item)"
                      class="btn btn-success mr-3"
                      v-if="!item.is_active && permissions.includes('CAN_ACTIVE_DEACTIVE_ROLE')"
                    >Active</v-btn>

                    <v-btn
                      @click="activationRole(item)"
                      class="btn btn-danger mr-3"
                      v-if="item.is_active && permissions.includes('CAN_ACTIVE_DEACTIVE_ROLE')"
                    >De-Active</v-btn>
                  </div>
                </td>
              </tr>
              <tr></tr>
            </tbody>
          </table>
        </div>
      </v-col>
    </div>
    <CModal
      :show.sync="permissionViewModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="History"
      size="lg"
      color="dark"
      :details="permissionModalData"
    >
      <div class="col-sm-12" v-if="permissionModalData && permissionModalData.length">
        <div class="form-group" v-for="(data, index) in permissionModalData" :key="index">
          <p>{{ showingName(data) }}</p>
          <hr />
        </div>
      </div>
      <template #header>
        <h6 class="modal-title">Permission</h6>
        <!-- <CButtonClose @click="permissionViewModal = false" class="text-white" /> -->
      </template>
      <template #footer>
        <CButton @click="permissionViewModal = false" color="danger">Cancel</CButton>
      </template>
    </CModal>
  </div>
</template>
<script>
import config from "@/config.js";
import _ from "lodash";
import { mapGetters } from "vuex";
export default {
  $_veeValidate: {
    validator: "new"
  },
  computed: {
    ...mapGetters({
      permissions: "getPermissions"
    })
  },
  data() {
    return {
      createRole: false,
      editRoleFlag: false,
      name: "",
      permissionResponseData: {},
      selectedRolePermissions: [],
      roleDataList: [],
      permissionViewModal: false,
      permissionModalData: [],
      editRolePermissions: [],
      roleId: ""
    };
  },
  mounted() {
    this.getRoles();
  },
  methods: {
    close() {
      this.createRole = false;
      this.editRoleFlag = false;
    },
    editRole(data) {
      this.roleId = "";
      this.createRole = true;
      this.editRoleFlag = true;
      this.name = data.name;
      this.roleId = data._id;
      this.getPermission();
      this.editRolePermissions = data.permissions;
      this.selectedRolePermissions = data.permissions;
    },
    editRoleData() {
      this.$validator.validate().then(valid => {
        if (valid) {
          let obj = {
            name: this.name,
            permissions: this.selectedRolePermissions,
            admin_role_id: this.roleId
          };
          let url = `${config.BASE_URL}api/v2/admin/roles`;
          this.$http.put(url, obj).then(response => {
            this.name = "";
            this.createRole = false;
            this.editRoleFlag = false;
            this.getRoles();
          });
        }
      });
    },
    activationRole(data) {
      let id = data._id;
      let activation = data.is_active ? false : true;
      let url = `${config.BASE_URL}api/v2/admin/roles/${id}/${activation}`;
      this.$http.put(url).then(response => {
        this.createRole = false;
        this.getRoles();
      });
    },
    openPermissionModal(data) {
      this.permissionViewModal = true;
      this.permissionModalData = data;
    },
    getRoles() {
      let url = `${config.BASE_URL}api/v2/admin/roles`;
      this.$http.get(url).then(response => {
        if (response.body.status) {
          this.roleDataList = response.body.data;
        }
      });
    },
    showingName(string) {
      let key = _.startCase(string);
      return key;
    },
    create() {
      this.createRole = true;
      this.editRolePermissions = [];
      this.getPermission();
    },
    selectPermission(item) {
      if (this.selectedRolePermissions.length > 0) {
        let newRole = this.selectedRolePermissions.indexOf(item);
        if (newRole != -1) {
          this.selectedRolePermissions.splice(newRole, 1);
        } else {
          this.selectedRolePermissions.push(item);
        }
      } else {
        this.selectedRolePermissions.push(item);
      }
    },
    getPermission() {
      let url = `${config.BASE_URL}api/v2/admin/roles/permissions`;
      this.$http.get(url).then(response => {
        if (response.body.status) {
          this.permissionResponseData = response.body.data;
        }
      });
    },
    createRoleData() {
      this.$validator.validate().then(valid => {
        if (valid) {
          let obj = {
            name: this.name,
            permissions: this.selectedRolePermissions
          };
          let url = `${config.BASE_URL}api/v2/admin/roles`;
          this.$http.post(url, obj).then(response => {
            this.name = "";
            this.createRole = false;
            this.getRoles();
          });
        }
      });
    }
  }
};
</script>